import { Routes } from '@angular/router';

import { authGuard } from './system/guards/auth/auth.guard';
import { isAuthGuard } from './system/guards/is-auth/is-auth.guard';
import { AnswerFormComponent } from './system/pages/answer-form/answer-form.component';
import { HomeComponent } from './system/pages/home/home.component';
import { LoginComponent } from './system/pages/login/login.component';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [authGuard],
  },
  {
    path: 'answer-form/:id',
    component: AnswerFormComponent,
    canActivate: [authGuard],
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [isAuthGuard],
  },
  {
    path: '**',
    redirectTo: '/login'
  }
];
